import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useOverlaySSE from './useOverlaySSE';
import api from '../../lib/api';
import './overlay.css';

export default function OverlayVoting() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [vote, setVote] = useState(null);
  const accentColor = searchParams.get('accent') || '#FF6B35';

  const fetchVote = useCallback(async () => {
    try {
      const res = await api.get(`/overlay/vote/public/${token}`);
      if (res.data && res.data.vote_id) setVote(res.data);
      else setVote(null);
    } catch { setVote(null); }
  }, [token]);

  useEffect(() => { fetchVote(); }, [fetchVote]);

  const handleEvent = useCallback((event) => {
    if (event.type === 'vote_update' && event.vote) {
      setVote(event.vote);
    }
  }, []);

  useOverlaySSE(token, handleEvent);

  if (!vote || !vote.options) return <div className="overlay-container" style={{ '--ov-accent': accentColor }} />;

  const totalVotes = vote.options.reduce((sum, o) => sum + (o.votes || 0), 0);

  return (
    <div className="overlay-container" style={{ '--ov-accent': accentColor }}>
      <div className="voting-container">
        <div className="voting-card">
          <div className="voting-title">🗳️ {vote.title}</div>
          {vote.options.map((opt, i) => {
            const pct = totalVotes > 0 ? Math.round((opt.votes / totalVotes) * 100) : 0;
            return (
              <div key={i} className="voting-option">
                <div className="voting-option-header">
                  <span className="voting-option-label">#{i + 1} {opt.label}</span>
                  <span className="voting-option-count">{opt.votes} votes ({pct}%)</span>
                </div>
                <div className="voting-bar-bg">
                  <div className="voting-bar-fill" style={{ width: `${pct}%` }} />
                </div>
              </div>
            );
          })}
          <div style={{ marginTop: 12, fontSize: 11, color: 'rgba(255,255,255,0.4)', fontWeight: 600 }}>
            Donatur kirim pesan #1, #2, dst untuk voting
          </div>
        </div>
      </div>
    </div>
  );
}
